<template>
    <v-dialog
        v-model="dialog"
        max-width="500"
        scrollable
    >
        <v-card style="overflow-y: auto; min-height: 90vh">
            <v-card-title class="headline zoezi-edit-color">
                {{$translate('Manage pages')}}
                <v-btn icon @click="dialog = false" class="ml-auto"><v-icon class="white--text">mdi-close</v-icon></v-btn>
            </v-card-title>

            <v-card-text class="pt-4">
                <v-text-field v-model="searchPage" label="Sök sida" append-icon="mdi-magnify" single-line hide-details color="zoezi-edit-color" clearable />
                <v-expansion-panels class="mt-2" v-model="expandedPage">
                    <v-expansion-panel v-for="(page,index) in sortedRoutes" :key="index">
                        <v-expansion-panel-header>{{page.name}}</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-text-field v-model="page.name" :label="$translate('Title')" color="zoezi-edit-color" @input="delayedSave"/>
                            <v-text-field v-model="page.path" :label="$translate('Path')" color="zoezi-edit-color" @input="delayedSave" />
                            <v-btn text color="error" @click="removePage(page)">{{$translate('Delete page')}}</v-btn>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-card-text>

        </v-card>
    </v-dialog>
</template>

<script>
import {debounce} from 'lodash';
export default {
    name: 'zoezi-manage-pages',

    props: ['value'],

    watch: {
        value: {
            immediate: true,
            handler() {
                this.dialog = this.value;
                if (this.dialog) {
                    this.searchPage = '';
                    this.expandedPage = null;
                    this.copyRoutes();
                }
            }
        },
        dialog() {
            this.$emit('input', this.dialog);
        }
    },

    computed: {
        sortedRoutes() {
            let s = (this.searchPage || '').toLowerCase();
            return this.routesCopy.filter(r => !s || r.path.includes(s) || r.name.toLowerCase().includes(s)).sort((a, b) => a.name.localeCompare(b.name));
        }
    },

    data: () => ({
        dialog: true,
        searchPage: '',
        debouncedSave: null,
        routesCopy: [],
        expandedPage: null
    }),

    methods: {
        removePage(page) {
            let i = this.$root.siteconfig.routes.map(r => r.props).findIndex(x => x === page);
            this.$root.siteconfig.routes.splice(i, 1);
            this.$root.saveHomePage();
            this.copyRoutes();
            this.expandedPage = null;

            if (this.$route.path == page.path) {
                this.$router.push({path: '/'});
            }
        },
        delayedSave() {
            this.debouncedSave();
        },
        copyRoutes() {
            this.routesCopy = this.$root.siteconfig.routes.map(r => r.props).sort((a, b) => a.name.localeCompare(b.name))
        }
    },
    mounted() {
        this.debouncedSave = debounce(() => this.$root.saveHomePage(), 1000);
    }
}
</script>
